import CommentAdd from './CommentAdd'

export default CommentAdd
// eslint-disable-next-line import/export
export * from './CommentAdd'
